const ru = {
  loading: 'Загрузка...',
  close: 'Закрыть',
  menu: 'Меню',
  search: 'Поиск',
  contextSearchHint: 'Спросите своими словами — подберём места Писания.',
  contextSearchPlaceholder: 'Например: прощение врагов, вера в испытаниях…',
  contextSearchSearching: 'Ищем…',
  contextSearchGoToRef: 'Открыть в Библии',
  contextSearchClear: 'Очистить поиск',
  bookmarks: 'Закладки',
  createBookmark: 'Создать закладку',
  addBookmark: 'Добавить',
  addingBookmark: 'Добавление…',
  addBookmarkTitle: 'Добавить закладку',
  history: 'История',
  settings: 'Настройки',
  bible: 'Библия',
  chat: 'Чат',
  chatActionLabel: 'Разбор',
  verseInsightButton: 'Объяснение',
  dailyVerse: 'Стих дня',
  homeInsightExplain: 'Объяснение',
  guestInsightLimit: 'Сегодня лимит бесплатных разборов исчерпан. Войдите по email — доступ без этого лимита.',
  exitFocusMode: 'Выйти из фокуса',
  chatVerseShowFull: 'Показать текст стиха',
  chatVerseCollapse: 'Свернуть текст стиха',
  chatUserQuestionPrefix: 'Вопрос пользователя:',
  chatVerseContextLabel: 'Вопрос по стиху:',
  chatEmptyWithVerse: 'Введите вопрос в поле ниже.',
  chatEmptyGeneral: 'Напишите вопрос по Библии.',
  chatStreamingHint: 'Ответ придет потоком, как в чате.',
  chatLoadingAnswer: 'Готовлю ответ...',
  chatFollowUpDeep: 'Разобрать глубже',
  chatFollowUpKeyThought: 'Ключевая мысль',
  chatFollowUpSimple: 'Просто и ясно',
  chatFollowUpSimpleShort: 'Просто',
  chatApplicationShort: 'Практика',
  chatFollowUpNewQuestion: 'Новый вопрос',
  chatComposerPlaceholderVerse: 'Ваш вопрос об этом стихе…',
  chatSend: 'Отправить',
  chatSuggestLabel: 'Можно спросить',
  chatSuggestMain: 'Что здесь главное?',
  chatSuggestSimple: 'Объясни простыми словами',
  chatSuggestApply: 'Как применить это сегодня?',
  chatComposerPlaceholderGeneral: 'Например: как понять Иакова 1:2?',
  chatTabsRowAria: 'Сохранённые диалоги',
  chatSessionUntitled: 'Новый чат',
  chatTabNewQuestion: 'Новый вопрос',
  chatTabCloseAria: 'Закрыть вкладку',
  chatTabNew: 'Новый чат',
  linkLabel: 'Ссылка',
  chapterWord: 'Глава',
  psalmWord: 'Псалом',
  verseWord: 'Стих',
  bookWord: 'Книга',
  home: 'Главная',
  bookChapterCount: '{count} глав',
  bookChapterCount_one: '{count} глава',
  bookChapterCount_few: '{count} главы',
  bookChapterCount_many: '{count} глав',
  verseImageMayTake: 'Генерация может занять 10-30 сек',
  verseImageNoIllustration: 'Для этого стиха пока нет иллюстрации в коллекции.',
  application: 'Применение',
  applicationEmpty: 'Применение пока не заполнено.',
  chapterSelectorSearchPlaceholder: 'Поиск книги и главы...',
  chapterSelectorSearchLabel: 'Поиск по книгам и главам',
  chapterSelectorDescriptionBookMissing: 'Не удалось загрузить описание: книга не выбрана',
  chapterSelectorNothingFound: 'Ничего не найдено. Попробуйте название книги, сокращение или номер главы.',
  chapterCountCompact: '{count} глав',
  chapterCountCompact_one: '{count} глава',
  chapterCountCompact_few: '{count} главы',
  chapterCountCompact_many: '{count} глав',
  bookSectionLabel: 'Раздел книги',
  bookmarkAuthRequired: 'Необходима авторизация. Пожалуйста, войдите снова.',
  signInRequiredForAi: 'Войдите по email, чтобы пользоваться толкованием, чатом, поиском и иллюстрациями.',
  bookmarkAddError: 'Ошибка при добавлении закладки',
  bookmarkLocationLabel: 'Место:',
  bookmarkTitleOptional: 'Заголовок (необязательно)',
  bookmarkTitlePlaceholder: 'Введите заголовок закладки',
  bookmarkTitleCounter: '{count}/{max} символов',
  bookmarksLoading: 'Загрузка закладок...',
  bookmarksEmpty: 'Закладок пока нет',
  bookmarksLoadError: 'Ошибка при загрузке закладок',
  bookmarkUntitled: 'Без названия',
  bookmarkChoose: 'Какую закладку перенести сюда?',
  bookmarkSelectTitle: 'Выбрать эту закладку',
  bookmarkSelect: 'Выбрать',
  bookmarkGoTitle: 'Перейти к закладке',
  bookmarkDeleteTitle: 'Удалить закладку',
  bookmarkDeleteConfirm: 'Удалить закладку?',
  bookmarkDeleteError: 'Ошибка при удалении закладки',
  bookmarkMoveError: 'Ошибка при перемещении закладки',
  savedTitle: 'Сохранённое',
  savedItemsTitle: 'Стихи и главы',
  ribbonsTitle: 'Закладки',
  savedEmpty: 'Нажмите на стих → «Сохранить». В Telegram напишите боту «🔖 Рим 8» или нажмите «Сохранить» под утренним сообщением.',
  ribbonsEmpty: 'Закладка отмечает, где вы остановились. Нажмите значок закладки в заголовке главы.',
  saveVerse: 'Сохранить',
  unsaveVerse: 'Убрать из сохранённого',
  savedDone: 'Сохранено',
  savedRemoved: 'Убрано из сохранённого',
  undoAction: 'Отменить',
  saveChapter: 'Сохранить главу',
  chapterSaved: 'Глава сохранена',
  newRibbon: 'Новая закладка',
  ribbonMoveHere: 'Сюда',
  ribbonMovedHere: 'Закладка «{name}» теперь здесь',
  historyClear: 'Очистить',
  historyClearConfirm: 'Очистить всю историю?',
  historyEmpty: 'История пуста',
  timeJustNow: 'только что',
  timeMinutesAgo: '{count} мин. назад',
  timeHoursAgo: '{count} ч. назад',
  chapters: 'Главы',
  description: 'Описание',
  retry: 'Попробовать снова',
  interpretation: 'Толкование',
  copyLink: 'Копировать ссылку',
  linkCopied: 'Ссылка скопирована!',
  copyManually: 'Скопируйте ссылку вручную',
  error: 'Ошибка',
  verse: 'Стих',
  openVerseMenu: 'открыть меню действий',
  parallels: 'Параллели',
  openPassage: 'Открыть',
  illustration: 'Иллюстрация',
  moreActions: 'Ещё',
  verseActions: 'Действия со стихом',
  share: 'Поделиться',
  note: 'Заметка',
  cancelAction: 'Отмена',
  chapterSelect: 'Выбор главы',
  previousChapter: 'Предыдущая глава',
  nextChapter: 'Следующая глава',
  noData: 'Нет данных',
  terms: 'Термины',
  theology: 'Богословие',
  christConnection: 'Связь со Христом',
  typology: 'Типология',
  crossReferences: 'Параллельные места',
  chatReferencesLabel: 'Ссылки',
  faqByText: 'Частые вопросы по тексту',
  noFaq: 'Нет данных FAQ для этого стиха',
  immediateContext: 'Ближайший контекст',
  contextTab: 'Контекст',
  bookContext: 'Контекст книги',
  biblicalContext: 'Библейский контекст',
  culture: 'Культура',
  historical: 'История',
  noCultureHistory: 'Нет данных о культуре и истории',
  faqTab: 'Вопросы',
  studyMeaning: 'Смысл',
  studySimple: 'Проще',
  studyKeyIdea: 'Главная мысль',
  studyAsk: 'Спросить об этом стихе…',
  botChatSent: 'Ответ печатается в чате с ботом',
  botChatOpen: 'Открыть',
  studyToolsAria: 'Разбор стиха',
  noSimple: 'Пока не получилось объяснить проще. Попробуйте ещё раз.',
  faqTabTitle: 'Вопросы по тексту',
  originalTab: 'Оригинал',
  originalLanguage: 'Оригинал',
  noOriginal: 'Нет данных об оригинале',
  principle: 'Принцип',
  today: 'Сегодня',
  noApplicationYet: 'Применение пока не заполнено для этого стиха.',
  analyzingScripture: 'Анализирую место Писания...',
  mayTakeMinutes: 'Это может занять несколько минут',
  loadingBookDescription: 'Загружаю описание книги...',
  mayTakeSeconds: 'Это может занять несколько секунд',
  aboutBook: 'О книге',
  verseExplain: 'Разобрать',
  verseInsightDialogAria: 'Разбор стиха',
  verseInsightExpand: 'Развернуть в чате',
  verseInsightAskQuestion: 'Задать вопрос',
  verseInsightThreadTitle: 'Уточнения',
  verseInsightVerseExpandAria: 'Развернуть текст стиха',
  verseInsightVerseCollapseAria: 'Свернуть текст стиха',
  verseOriginal: 'Оригинал',
  chatApplyLifeLabel: 'Применить к реальной жизни',
  chatApplyLifePrompt: 'Как применить к реальной жизни?',
  appLanguage: 'Язык',
  readingSettingsTabDisplay: 'Экран',
  readingFont: 'Шрифт чтения',
  settingsTitle: 'Настройки',
  settingsLogout: 'Выйти',
  loginByEmailForFeatures: 'Вход по email для доступа к функциям',
  loginOpenedInTelegram: 'Открыто в Telegram',
  loginTelegramAutoAuth: 'Авторизация должна произойти автоматически',
  loginCheckEmailLinkSent: '📩 Проверьте email адрес, ссылка успешно отправлена.',
  loginSendAgain: 'Отправить ещё раз',
  loginSending: 'Отправка...',
  loginByEmailButton: '✉️ Войти по email',
  loginTelegramRefreshHint: 'Если авторизация не произошла автоматически, обновите страницу',
  loginEmailReturnHint: 'После входа ссылка из письма откроет приложение с тем же адресом возврата.',
  loginSuccessByLink: 'Вход по ссылке выполнен',
  loginLinkInvalidOrExpired: 'Ссылка недействительна или устарела',
  loginSuccess: 'Вход выполнен',
  loginError: 'Ошибка входа',
  loginEnterEmail: 'Введите email',
  loginSendLinkFailed: 'Не удалось отправить ссылку',
  settingsBackAria: 'Назад',
  settingsLanguageHelp: 'Выберите язык интерфейса и переводов. Толкование будет на выбранном языке.',
  settingsReadingFontHelp: 'Шрифт для текста стихов в режиме чтения.',
  settingsTranslationsLabel: 'Переводы',
  languagePromptTitle: 'Пожалуйста, выберите язык',
  commonError: 'Ошибка',
  taskLoadError: 'Ошибка загрузки',
  taskTemplateResetDone: 'Шаблон сброшен!',
  taskResetError: 'Ошибка сброса',
  taskDone: 'Задача выполнена!',
  taskDeleted: 'Задача удалена',
  taskDeleteError: 'Ошибка удаления',
  taskFilterTodo: 'К выполнению',
  taskFilterCompleted: 'Выполненные',
  taskTemplates: 'Шаблоны',
  taskEmpty: 'Нет задач',
  taskNavToday: 'Сегодня',
  taskNavAll: 'Все',
  taskCreateTitle: 'Создание задачи',
  taskEditTitle: 'Редактирование задачи',
  taskNameLabel: 'Название задачи:',
  taskNamePlaceholder: 'Название задачи',
  taskTagsLabel: 'Теги:',
  taskContactsLabel: 'Контакты:',
  taskChecklistLabel: 'Чек-лист',
  taskCreateAction: 'Создать',
  taskSaveAction: 'Сохранить',
  taskNotFound: 'Задача не найдена',
  taskUpdateError: 'Ошибка обновления',
  taskDeleteConfirm: 'Удалить задачу?',
  taskReopened: 'Задача возобновлена',
  taskActionResetTemplate: 'Сбросить шаблон',
  taskActionComplete: 'Завершить задачу',
  taskActionReopen: 'Возобновить',
  taskActionDelete: 'Удалить',
  dailyAiLimitReached: 'Вы достигли дневного лимита запросов.',
  dailyAiTypedLimitReached: 'Вы достигли дневного лимита для этого типа запросов.',
  dailyInterpretationLimitReached: 'Вы достигли дневного лимита толкований.',
  dailyChatLimitReached: 'Вы достигли дневного лимита запросов. Завтра снова можно будет выполнить запросы.',
  dailyDeepExplainLimitReached: 'Вы достигли дневного лимита глубоких объяснений.',
  dailyContextSearchLimitReached: 'Вы достигли дневного лимита поиска.',
  dailyContextSearchStreamLimitReached: 'Вы достигли дневного лимита поиска.',
  dailyVerseImageLimitReached: 'Вы достигли дневного лимита генерации изображений.',
  contextSearchGroupSingle: '{book} — 1 стих: {reference}',
  contextSearchGroupCount_one: '{book} — {count} стих',
  contextSearchGroupCount_few: '{book} — {count} стиха',
  contextSearchGroupCount_many: '{book} — {count} стихов',
  contextSearchGroupCount_other: '{book} — {count} стихов',
  interpretationLoadSoftErrorTitle: 'Не удалось получить толкование',
};

export default ru;
